var map = {
	"./about-left.webp": 4588,
	"./about.webp": 9098,
	"./abt-cake.png": 9579,
	"./abt1-cake.png": 4938,
	"./abtcake.png": 5716,
	"./cake-b.png": 3182,
	"./cake-banner.webp": 5462,
	"./cake-bg.png": 6867,
	"./cake-blog.png": 6926,
	"./cake-color.png": 6465,
	"./cake-detail.webp": 5969,
	"./cake-list.png": 6102,
	"./cake-typo.png": 5388,
	"./cake1.png": 6338,
	"./cake1.webp": 5032,
	"./cake2.png": 2425,
	"./cake2.webp": 1141,
	"./cake3.png": 6176,
	"./cake3.webp": 522,
	"./cake4.png": 2047,
	"./cake4.webp": 2055,
	"./cake5.webp": 9460,
	"./cake6.webp": 6945,
	"./cake7.webp": 1622,
	"./cake8.webp": 2960,
	"./cakebanner.png": 7121,
	"./cakebg.png": 6546,
	"./cakephone.png": 2847,
	"./cakephone2.png": 3597,
	"./category-cake.png": 2942,
	"./detail.png": 7564,
	"./detail.webp": 7116,
	"./homepage-cake.png": 2778,
	"./line2-01.png": 1075,
	"./multi-phone.png": 8723,
	"./ntdlg.svg": 140,
	"./show1.png": 9319,
	"./show2.png": 5183,
	"./show3.png": 4101,
	"./ssc-mockup.png": 1120,
	"./ssc-phone2.png": 5507,
	"./ssc-phone3.png": 4746,
	"./ssc-phone4.png": 3061,
	"./ssc-phone5.png": 5548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5855;